// socket.js
import { io } from "socket.io-client";

export default function createSocket(userDetails){
  return io(process.env.REACT_APP_API_URL, {
    autoConnect: false, // control connection manually
    transports: ["polling"],
    auth: {
      role: "doctor",
      _id: userDetails?.DoctorProfile?._id || null,
    },
  });
};
